import { render, staticRenderFns } from "./DatosDespachoUsuario.vue?vue&type=template&id=4e578829"
import script from "./DatosDespachoUsuario.vue?vue&type=script&lang=js"
export * from "./DatosDespachoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports